/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_UpInputs */



/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Common_Sign_UpInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const common_sign_up = /** @type {((inputs?: Common_Sign_UpInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_UpInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Registrieren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer un compte")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("注册")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("註冊")
	if (locale === "ko") return /** @type {LocalizedString} */ ("회원가입")
	return /** @type {LocalizedString} */ ("Sign up")
});